import styled from 'styled-components';

export const CompanySiteLayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;

  .company-site-header {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    padding: 12px 0;
  }

  .company-site-header-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
  }

  .company-site-logo {
    height: 44px;
    width: auto;
    object-fit: contain;
  }

  .company-site-nav {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .company-site-nav a {
    color: #1a1a1a;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    padding: 8px 14px;
    border-radius: 8px;
    transition: background 0.2s, color 0.2s;
  }

  .company-site-nav a:hover {
    background: #f0f0f0;
    color: var(--bg-primary, #1890ff);
  }

  .company-site-main {
    flex: 1;
    width: 100%;
  }

  .company-site-footer {
    margin-top: auto;
    background: #1a1a1a;
    color: rgba(255, 255, 255, 0.85);
    padding: 40px 24px 24px;
  }

  .company-site-footer-inner {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
  }

  .company-site-footer-logo {
    height: 36px;
    width: auto;
    object-fit: contain;
    margin-bottom: 16px;
    opacity: 0.95;
  }

  .company-site-footer p {
    margin: 0;
    font-size: 13px;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    .company-site-header-inner {
      padding: 0 16px;
    }
    .company-site-nav a {
      padding: 6px 10px;
      font-size: 13px;
    }
  }
`;
